import './PrivacyTerm.css'
import React, { Component} from 'react'
import Header from '../template/Header'
import TermText from './TermText'

export default class PrivacyTerm extends Component{

    state={
        currentPage: 0,
        requiredContact: false,
        requiredAddress: false,
        message: '',
        publishQuestion: false,
    }

    render(){
            return(
                <React.Fragment>
                <div className="termContainer">
                <Header />
                    <div className="term">
                        <div className="section">
                        <TermText/>
                        </div>
                    </div>
                </div>
                </React.Fragment>
            )
    }
}

// const mapStateToProps = ({local, user}) => {
//     return {local, user}
// }

// const mapDispatchToProps = dispatch => {
//     return{
//         onSubmit : (local, user, visibility) => dispatch(localPost(local, user, visibility)),
//         onLogout : () => dispatch(signOut()),
//         onRepeat : () => dispatch(localClear()),
//     }
// }

// export default connect(mapStateToProps,mapDispatchToProps)(LocalForm)